import { HttpMethod } from '@previo/core'
import Http from '~/http/Http'
import { APIPaths } from '~/http/APIPaths'
import type { ZipResponse, ZipSuggestionResponse } from '~/http/zips/Zips'

export class ZipsAPI extends Http {
  suggestZips = (search: string): Promise<ZipSuggestionResponse> => {
    return this.callAuthAPI<null, ZipSuggestionResponse>(
      HttpMethod.GET,
      { path: APIPaths.ZIPS_SUGGEST, query: { keyword: search } },
      null,
    )
  }

  getZip = (zipId: number): Promise<ZipResponse> => {
    return this.callAuthAPI<null, ZipResponse>(
      HttpMethod.GET,
      { path: APIPaths.ZIP_DETAIL, params: { zipId } },
      null,
    )
  }
}
